var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFounder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "founder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2084375%",
    y1: "-13.9583437%",
    x2: "50.7915625%",
    y2: "114.666562%",
    id: "founder-linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "founder-linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.15,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.2084372%",
    y1: "-13.9583149%",
    x2: "50.7915628%",
    y2: "114.666533%",
    id: "founder-linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50.0001375%",
    x2: "0%",
    y2: "50.0001375%",
    id: "founder-linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.05,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "founder",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,32 C24.8366,32 32,24.8366 32,16 C32,7.16344 24.8366,0 16,0 C7.16344,0 0,7.16344 0,16 C0,24.8366 7.16344,32 16,32 Z",
    id: "Path",
    fill: "url(#founder-linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,32 C24.8366,32 32,24.8366 32,16 C32,7.16344 24.8366,0 16,0 C7.16344,0 0,7.16344 0,16 C0,24.8366 7.16344,32 16,32 Z",
    id: "Path",
    fill: "url(#founder-linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,29.0375 C23.2004,29.0375 29.0375,23.2004 29.0375,16 C29.0375,8.79958 23.2004,2.96249 16,2.96249 C8.79959,2.96249 2.9625,8.79958 2.9625,16 C2.9625,23.2004 8.79959,29.0375 16,29.0375 Z",
    id: "Path",
    fill: "#FEB635",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,29.0375 C23.2004,29.0375 29.0375,23.2004 29.0375,16 C29.0375,8.79958 23.2004,2.96249 16,2.96249 C8.79959,2.96249 2.9625,8.79958 2.9625,16 C2.9625,23.2004 8.79959,29.0375 16,29.0375 Z",
    id: "Path",
    fill: "url(#founder-linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0375,16 C29.0375,23.1875 23.1875,29.0375 16,29.0375 C13.6563,29.0375 11.4625,28.4187 9.5625,27.3312 C11.3125,28.2062 13.2875,28.7 15.375,28.7 C22.5625,28.7 28.4125,22.85 28.4125,15.6625 C28.4125,10.8188 25.75,6.58125 21.8125,4.3375 C26.0938,6.475 29.0375,10.8938 29.0375,16 Z M16.8875,3.575 C19.4563,3.575 21.85,4.325 23.8625,5.60625 C21.675,3.95625 18.95,2.96875 16,2.96875 C8.8125,2.96875 2.9625,8.8125 2.9625,16.0063 C2.9625,20.6437 5.4,24.7313 9.0625,27.0312 C5.9,24.65 3.85,20.8687 3.85,16.6125 C3.85,9.425 9.7,3.575 16.8875,3.575 Z",
    id: "Shape",
    fillOpacity: 0.05,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.8,
    fill: "#000000",
    fillRule: "nonzero",
    points: "18.5966 9.45456 18.5966 24 14.6477 24 14.6477 13.0909 14.5625 13.0909 11.3807 14.9943 11.3807 11.6421 14.9602 9.45456"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.5,
    fill: "url(#founder-linearGradient-4)",
    fillRule: "nonzero",
    points: "18.5966 9.45456 18.5966 24 14.6477 24 14.6477 13.0909 14.5625 13.0909 11.3807 14.9943 11.3807 11.6421 14.9602 9.45456"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 0.350269,
    points: "18.5966 9.45456 18.5966 24 14.6477 24 14.6477 13.0909 14.5625 13.0909 11.3807 14.9943 11.3807 11.6421 14.9602 9.45456"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounder);
export default __webpack_public_path__ + "static/media/founder.8dfc4c5e62da7af9aee5e8c197894e95.svg";
export { ForwardRef as ReactComponent };